export const state = {
    suppliers_loading_status: null, // when waiting on api we set this true or false
    //will be an object
    suppliers_selected_client: null, //the client details of a supplier
    suppliers_client_details: null, // contains name and id
    selected_supplier_details: null, //the details for a supplier
    // ! FIX in future to seperate name and id
    supplier_name_heading: null, // set when the client suppliers page is loaded, id also

    client_suppliers: [], // all suppliers for a client

    supplier_certificates: [], // all of specific suppliers certificates
    selected_supplier_certificate: [], // only a specific certificate

    agencies: [],

    searchFor_certificates_details: null, // capture details of certificate to search for
    result_of_searched_certificates: [], //certificates returned from a seach
    selected_searched_certificate: null, // selcted a certificate to view from the result

    //add suppliers Modal
    suppliers_to_update: [],
    suppliers_to_add: [],

    //editModal
    teamMembersForCertificates: [],
    teamManagersForCertificates: [],
    qcUsersForCertificates: [],

    //suppliers
    suppliersToDeleteIds: [],
};

export const getters = {};

export const actions = {
    setLoadingStatus({ commit }, value) {
        commit("setLoadingStatus", value);
    },
    //eslint-disable-next-line
    setSuppliersSelectedClient({ commit }, details) {
        commit("setSuppliersSelectedClient", details);
    },
    //eslint-disable-next-line
    setSupplierDetails({ commit }, details) {
        commit("setSupplierDetails", details);
    },
    //eslint-disable-next-line
    setSelectedCertificate({ commit }, details) {
        commit("setSelectedCertificate", details);
    },
    setSearchForCertificatesDetails({ commit }, details) {
        commit("setSearchForCertificatesDetails", details);
    },
    setSelectedSearchedCertificate({ commit }, details) {
        commit("setSelectedSearchedCertificate", details);
    },

    setSuppliers({ commit, state }, url = state.selected_clientid_suppliers) {
        return new Promise((resolve, reject) => {
            commit("setSuppliersLoadingStatus", true);
            window.axios
                .get("api/certificates/clientsuppliers", {
                    params: { client_id: url },
                })
                .then((response) => {
                    commit("setSuppliers", response.data);
                    commit("setSuppliersLoadingStatus", false);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setSupplierCertificates({ commit, state }, id) {
        return new Promise((resolve, reject) => {
            commit("setSuppliersLoadingStatus", true);
            window.axios
                .get("api/certificates/suppliercertificates", {
                    params: { supplier_id: id },
                })
                .then((response) => {
                    commit("setSupplierCertificates", response.data);
                    commit("setSuppliersLoadingStatus", false);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setAgencies({ commit, state }) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/admin/agencies")
                .then((response) => {
                    commit("setAgencies", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    // set active
    // eslint-disable-next-line
    updateClientSupplierCertificateDetails({ commit, state }, requestObject) {
        const formData = new FormData();

        for (let data in requestObject) {
            formData.append(data, requestObject[data]);
        }
        const headers = { "Content-Type": "multipart/form-data" };

        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/updateclientsuppliercertificatedetails", formData, { headers })
                .then((response) => {
                    commit("setTeamMembers", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
        // return new Promise((resolve, reject) => {
        //     window.axios
        //         .post("api/certificates/updateclientsuppliercertificatedetails", requestObject)
        //         //eslint-disable-next-line
        //         .then((response) => {
        //             resolve();
        //         })
        //         .catch(() => {
        //             reject();
        //         });
        // });
    },
    // eslint-disable-next-line
    updateActiveClientSupplierCertificate({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/updateactiveclientsuppliercertificate", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    deleteClientSupplierCertificate({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/deleteclientsuppliercertificate", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    // deletes from bee certificate
    //eslint-disable-next-line
    deleteBEECertificate({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/deletecertificate", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    searchCertificates({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/certificates/searchcertificates", {
                    params: requestObject,
                })
                .then((response) => {
                    commit("searchCertificates", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    duplicateClientSupplierCertificate({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/duplicateclientsuppliercertificate", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //adds a new certificate to the database
    //eslint-disable-next-line
    saveClientSupplierCertificateDetails({ commit, state }, requestObject) {
        const formData = new FormData();

        for (let data in requestObject) {
            formData.append(data, requestObject[data]);
        }

        // formData.append("certificate", requestObject.certificate);
        const headers = { "Content-Type": "multipart/form-data" };

        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/addclientsuppliercertificatedetails", formData, { headers })
                //eslint-disable-next-line
                .then((response) => {
                    // commit("setSelectedCertificate", response.data.certificate_id);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //send the input sheet data to the backend
    //eslint-disable-next-line
    checkBeforeAddSuppliers({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/checkbeforeaddsuppliers", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    commit("checkBeforeAddSuppliers", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    // method that resets suppliers_to_update & suppliers_to_add to empty array's
    resetAddSuppliersToEmpty({ commit }) {
        commit("resetAddSuppliersToEmpty");
    },

    //eslint-disable-next-line
    saveAddUpdateSuppliers({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/saveaddupdatesuppliers", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    //eslint-disable-next-line
    downloadCertificate({ commit, state }, certificate_id) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/certificates/downloadcertificate", {
                    params: { certificate_id: certificate_id },
                })
                //eslint-disable-next-line
                .then((response) => {
                    let link = document.createElement("a");
                    link.href = response.data.url;
                    link.target = "_blank";
                    link.download = "certificate.pdf";
                    link.click();

                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    //eslint-disable-next-line
    // setTeamMembersForCertificates({ commit }, requestObject) {
    //     return new Promise((resolve, reject) => {
    //         window.axios
    //             .get("api/admin/roleusers", { params: { role_name: "Certificate Team" } })
    //             .then((response) => {
    //                 commit("setTeamMembersForCertificates", response.data);
    //                 resolve();
    //             })
    //             .catch(() => {
    //                 reject();
    //             });
    //     });
    // },
    // //eslint-disable-next-line
    // setTeamManagersForCertificates({ commit }, requestObject) {
    //     return new Promise((resolve, reject) => {
    //         window.axios
    //             .get("api/admin/roleusers", { params: { role_name: "Team Manager" } })
    //             .then((response) => {
    //                 commit("setTeamManagersForCertificates", response.data);
    //                 resolve();
    //             })
    //             .catch(() => {
    //                 reject();
    //             });
    //     });
    // },
    //eslint-disable-next-line
    setTeamMembersForCertificates({ commit }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/admin/roleusers", { params: { role_name: "Certificate Team" } })
                .then((response) => {
                    commit("setTeamMembersForCertificates", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    shareCertificate({ commit }, requestObject) {
        const formData = new FormData();

        for (let data in requestObject) {
            formData.append(data, requestObject[data]);
        }
        const headers = { "Content-Type": "multipart/form-data" };

        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/sharecertificate", formData, { headers })
                .then((response) => {
                    commit("setTeamMembers", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setCertificateById({ commit, state }, id) {
        return new Promise((resolve, reject) => {
            // commit("setSuppliersLoadingStatus", true);
            window.axios
                .get("api/certificates/getcertificatebyid", {
                    params: { certificate_id: id },
                })
                .then((response) => {
                    commit("setSelectedCertificate", response.data[0]);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    updateSuppliersToDeleteIds({ commit }, data) {
        commit("updateSuppliersToDeleteIds", data);
    },
    addSuppliersToDeleteIds({ commit }, data) {
        commit("addSuppliersToDeleteIds", data);
    },
    removeSuppliersToDeleteIds({ commit }, data) {
        commit("removeSuppliersToDeleteIds", data);
    },
    resetSuppliersToDeleteIds({ commit }, data) {
        commit("resetSuppliersToDeleteIds", data);
    },
    //eslint-disable-next-line
    shareCertificate({ commit }, requestObject) {
        const formData = new FormData();

        for (let data in requestObject) {
            formData.append(data, requestObject[data]);
        }
        const headers = { "Content-Type": "multipart/form-data" };

        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/sharecertificate", formData, { headers })
                .then((response) => {
                    commit("setTeamMembers", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    updateClientSupplier({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/certificates/updateclientsupplier", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
};

export const mutations = {
    setSuppliersSelectedClient(state, payload) {
        state.suppliers_selected_client = payload;
    },
    setSupplierDetails(state, payload) {
        state.selected_supplier_details = payload;
    },
    setSelectedCertificate(state, payload) {
        state.selected_supplier_certificate = payload;
    },
    setSearchForCertificatesDetails(state, payload) {
        state.searchFor_certificates_details = payload;
    },
    setSelectedSearchedCertificate(state, payload) {
        state.selected_searched_certificate = payload;
    },
    setSuppliers(state, payload) {
        state.client_suppliers = payload["suppliers"];

        state.suppliers_client_details = { name: payload["client_details"].name, client_id: payload["client_details"].id };
    },
    setSupplierCertificates(state, payload) {
        state.supplier_certificates = payload;
    },
    setSuppliersLoadingStatus(state, payload) {
        state.suppliers_loading_status = payload;
    },
    setAgencies(state, payload) {
        state.agencies = payload;
    },
    searchCertificates(state, payload) {
        state.result_of_searched_certificates = payload;
    },
    checkBeforeAddSuppliers(state, payload) {
        state.suppliers_to_update = payload["update"];
        state.suppliers_to_add = payload["add"];
    },
    resetAddSuppliersToEmpty(state) {
        state.suppliers_to_update = [];
        state.suppliers_to_add = [];
    },
    setTeamMembersForCertificates(state, payload) {
        //eslint-disable-next-line
        console.log("the team memebrs thing", payload);

        state.teamManagersForCertificates = null;
        state.teamManagersForCertificates = [];
        state.qcUsersForCertificates = null;
        state.qcUsersForCertificates = [];
        //all are added to team members
        state.teamMembersForCertificates = payload;

        //eslint-disable-next-line
        console.log("checking payload", payload);

        for (let i = 0; i < payload.length; i++) {
            if (payload[i].permissions.length > 0) {
                for (let k = 0; k < payload[i].permissions.length; k++) {
                    if (payload[i].permissions[k].name == "QC BEE Data") {
                        state.qcUsersForCertificates.push(payload[i]);
                    }

                    if (
                        payload[i].permissions[k].name == "Add, Edit and Delete Team Members" ||
                        payload[i].permissions[k].name == "Add and Remove Collection Clients" ||
                        payload[i].permissions[k].name == "Assign and Remove Team Members for Collections"
                    ) {
                        //eslint-disable-next-line
                        function checkWetherUserIdAlreadySet(id) {
                            //search for permission
                            let findId = state.teamManagersForCertificates.find((findId) => findId.id == id);
                            //tpye cast to true or false if the the permission is undefined i.e. none existant
                            return typeof findId !== "undefined";
                        }

                        //eslint-disable-next-line
                        // console.log("payload before saerch", payload[i], searchForPermission(payload[i].id));

                        //if not in the array
                        if (checkWetherUserIdAlreadySet(payload[i].id) == false) {
                            state.teamManagersForCertificates.push(payload[i]);
                        }
                    }
                }
            }
        }
    },

    addSuppliersToDeleteIds(state, payload) {
        const index = state.suppliersToDeleteIds.indexOf(payload);

        if (index === -1) {
            //Its not in the array add it
            // If 5 is not in the array, push it
            state.suppliersToDeleteIds.push(payload);
        } else {
            //it is in the array dont do anything
        }
    },
    removeSuppliersToDeleteIds(state, payload) {
        const index = state.suppliersToDeleteIds.indexOf(payload);

        if (index >= 0) {
            //remove
            state.suppliersToDeleteIds.splice(index, 1);
        }
    },
    //eslint-disable-next-line
    resetSuppliersToDeleteIds(state, payload) {
        state.suppliersToDeleteIds = null;
        state.suppliersToDeleteIds = [];
    },
};
